module.exports = __webpack_public_path__ + "img/ClassDiagram.75fab4be.png";